var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 7.08341C14.1666 4.78223 12.3011 2.91675 9.99992 2.91675C7.69874 2.91675 5.83325 4.78223 5.83325 7.08341C5.83325 9.38458 7.69874 11.2501 9.99992 11.2501C12.3011 11.2501 14.1666 9.38458 14.1666 7.08341Z",
    stroke: "#7157C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 17.0833C15.8334 13.8617 13.2217 11.25 10.0001 11.25C6.77842 11.25 4.16675 13.8617 4.16675 17.0833",
    stroke: "#7157C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.9d7e4cdcbf40742018cbf6992c138991.svg";
export { ForwardRef as ReactComponent };